import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'di-navbar-right-menu',
  templateUrl: './navbar-right-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavbarRightMenuComponent {}
